<template>
    <form @submit.prevent="submit">
        <input type="text"
               v-model="username"
               id="username"
               name="username"
               autocomplete="username"
               class="form-control dark"
               :class="{error: formErrors.username}"
               :placeholder="trans('home.login')"
               @input="usernameChanged"
        >

        <input type="password"
               v-model="password"
               id="password"
               name="password"
               autocomplete="current-password"
               class="form-control dark"
               :class="{error: formErrors.password}"
               :placeholder="trans('home.password')"
               @input="passwordChanged"
        >

        <button
            type="submit"
            class="btn btn-primary btn-rounded"
            id="login-button"
        >{{trans('home.log_in')}}</button>

        <div class="form-footer">
            <div class="checkbox-container">
                <label class="checkbox-label">
                    <input type="checkbox" v-model="remember">
                    <span class="checkbox-custom"></span>
                    <div class="input-title">{{ trans('home.remember_me') }}</div>
                </label>
            </div>
            <a class="forgot-pass" @click="recoverPassword">{{ trans('home.forgot_password') }}</a>
        </div>
    </form>
</template>

<script>
    import {mapActions, mapGetters, mapState} from 'vuex';

    export default {
        data: () => ({
            username: null,
            password: null,
            remember: true,

            formErrors: {
                username: null,
                password: null
            }
        }),
        mixins: [
            require('@general/lib/mixin').default
        ],
        methods: {
            ...mapActions({
                login: 'login'
            }),
            recoverPassword() {
              const isMobile = app.isMobile;

              if (isMobile || this.$parent.$options._componentTag === "modal-join") {
                  location.href = '/recover-password';
              } else {
                  this.openRecoverPasswordModal();
              }
            },

      usernameChanged(){
                if (this.formErrors.username) {
                    this.formErrors.username = null
                }
            },
            passwordChanged(){
                if (this.formErrors.password) {
                    this.formErrors.password = null
                }
            },
            validate(){
                let valid = true
                if (!this.username) {
                    this.formErrors.username = true
                    valid = false
                }
                if (!this.password) {
                    this.formErrors.password = true
                    valid = false
                }
                return valid
            },
            async loginAndRedirect(){
                this.showLoadingButton('#login-button')
                try {
                    let loggedInSuccessfully = await this.login({
                        username: this.username,
                        password: this.password,
                        remember: this.remember
                    })
                    console.log('[Login Form] Result', { loggedInSuccessfully })

                    if (loggedInSuccessfully) {
                      window.history.pushState({'id':1},'/discover','/discover');
                      window.location.reload();
                    }else{
                      this.restoreLoadingButton('#login-button')
                    }
                } catch (error) {
                    console.log('[Login Form] Error', { error })
                    let output = error.data;
                    if(error.data.error === 'invalid_credentials'){
                      output = app.trans('invalid_credentials');
                    }
                    this.showNotification(output, 'error');
                }

                this.restoreLoadingButton('#login-button')
            },
            submit(){
                console.log('[Login Form] Submit')
                if (this.validate()){
                    this.loginAndRedirect()
                }
            }
        }
    }
</script>

<style scoped>

</style>